import { render } from "./MathFormula.vue?vue&type=template&id=61ef32f6"
import script from "./MathFormula.vue?vue&type=script&lang=js"
export * from "./MathFormula.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__